import { useMutation } from "@tanstack/react-query";

import { axios } from "@/client/libs/axios";
import { queryClient } from "@/client/libs/query-client";
import { useAuthStore } from "@/client/stores/auth";

export const logout = () => axios.post("/auth/logout");

const clearAllStorage = () => {
  // Clear Zustand persisted auth state
  localStorage.removeItem("auth");

  // Clear session storage
  sessionStorage.clear();

  // Clear all cookies (client-side accessible only)
  document.cookie.split(";").forEach((c) => {
    document.cookie = c.replace(/^ +/, "").replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
  });
};

export const useLogout = () => {
  const setUser = useAuthStore((state) => state.setUser);

  const {
    error,
    isPending: loading,
    mutateAsync: logoutFn,
  } = useMutation({
    mutationFn: logout,
    onSuccess: () => {
      // Clear user state
      setUser(null);

      // Clear React Query cache
      queryClient.clear();

      // Clear all persistent storage
      clearAllStorage();
    },
    onError: () => {
      // Even on error, clear everything locally
      setUser(null);
      queryClient.clear();
      clearAllStorage();
    },
  });

  return { logout: logoutFn, loading, error };
};
